var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.269,
    height: 147.269,
    viewBox: "0 0 147.269 147.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -1247.371, 70.893)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "matrix(0.911, -0.412, 0.412, 0.911, 1276.38, 191.939)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(1287.182 187.221) rotate(-9.701)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "matrix(0.997, 0.078, -0.078, 0.997, 1299.749, 185.523)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "W",
    transform: "translate(1310.995 186.394) rotate(20.839)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "matrix(0.197, 0.98, -0.98, 0.197, 1243.75, 238.873)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(1246.984 252.374) rotate(63.009)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "U",
    transform: "translate(1255.424 267.211) rotate(46.366)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    "data-name": "R",
    transform: "matrix(0.859, 0.512, -0.512, 0.859, 1266.875, 278.292)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": " ",
    transform: "matrix(0.942, 0.335, -0.335, 0.942, 1279.69, 285.099)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": " ",
    transform: "matrix(0.977, 0.215, -0.215, 0.977, 1286.527, 287.324)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": " ",
    transform: "translate(1293.569 288.545) rotate(5.211)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": " ",
    transform: "translate(1300.595 288.975) rotate(-1.814)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": " ",
    transform: "translate(1307.665 288.598) rotate(-8.935)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": " ",
    transform: "matrix(0.961, -0.278, 0.278, 0.961, 1314.64, 287.17)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "E-2",
    "data-name": "E",
    transform: "matrix(0.894, -0.448, 0.448, 0.894, 1321.775, 285.076)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "translate(1333.992 278.433) rotate(-41.925)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "J",
    transform: "matrix(0.563, -0.826, 0.826, 0.563, 1345.581, 266.851)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "J")), /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    "data-name": "O",
    transform: "translate(1351.736 257.538) rotate(-69.802)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "Y",
    transform: "translate(1356.725 241.471) rotate(-85.173)",
    fill: "#231f20",
    fontSize: 15.625,
    fontFamily: "BrandonGrotesque-Black, Brandon Grotesque",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 40.677,
    cy: 40.677,
    r: 40.677,
    transform: "translate(1259.783 191.413)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.395
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 62.865,
    cy: 62.865,
    r: 62.865,
    transform: "translate(1237.595 169.225)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 20.74,
    y2: 8.713,
    transform: "translate(1338.362 208.599)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 20.74,
    y2: 8.713,
    transform: "translate(1242.135 208.599)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.395
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 21.786,
    transform: "translate(1300.46 273.169)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.395
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1279.776,225.552h-7.789a.3.3,0,0,0-.318.335v12.161a.3.3,0,0,0,.318.336h7.789a.3.3,0,0,0,.318-.336v-.894a.3.3,0,0,0-.318-.335h-6.345V232.66h5.219a.3.3,0,0,0,.317-.334v-.9a.3.3,0,0,0-.317-.335h-5.219v-3.979h6.345a.3.3,0,0,0,.318-.335v-.9a.3.3,0,0,0-.318-.335",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1288.272,231.64l-2.816-.9c-1.352-.436-1.9-1.014-1.9-2,0-1.172,1.02-1.9,2.661-1.9a2.9,2.9,0,0,1,3.07,2.124.348.348,0,0,0,.342.29h1.014a.309.309,0,0,0,.244-.1.359.359,0,0,0,.071-.3c-.434-2.274-2.162-3.578-4.741-3.578-2.645,0-4.422,1.428-4.422,3.554,0,1.712.931,2.844,2.845,3.458l2.818.895c1.321.419,1.885,1.016,1.885,2,0,1.19-1.055,1.9-2.822,1.9s-2.871-.714-3.293-2.122a.345.345,0,0,0-.344-.29h-1.014a.306.306,0,0,0-.241.1.359.359,0,0,0-.073.3c.44,2.308,2.2,3.58,4.965,3.58,2.785,0,4.584-1.395,4.584-3.554,0-1.7-.952-2.866-2.829-3.458",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1298.491,225.552h-4.668a.3.3,0,0,0-.317.335v12.161a.3.3,0,0,0,.317.336h1.127a.3.3,0,0,0,.318-.336V234.27h3.223c2.8,0,4.343-1.548,4.343-4.358s-1.543-4.36-4.343-4.36m2.581,4.36c0,1.8-.917,2.793-2.581,2.793h-3.223v-5.588h3.223c1.664,0,2.581.992,2.581,2.795",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1322.568,225.528a6.684,6.684,0,1,0,6.684,6.685,6.693,6.693,0,0,0-6.684-6.685m4.963,6.685a4.964,4.964,0,1,1-4.963-4.965,4.969,4.969,0,0,1,4.963,4.965",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1312.934,234.663c-.174-.3-.66-1.138-1-1.7a3.532,3.532,0,0,0,2.469-3.412c0-2.5-1.623-4-4.341-4h-4.506a.3.3,0,0,0-.319.335v12.161a.3.3,0,0,0,.319.336h1.125a.3.3,0,0,0,.318-.336v-4.493h3.2l.774,1.264,1.932,3.31a.445.445,0,0,0,.375.255h1.32a.3.3,0,0,0,.293-.138.3.3,0,0,0-.029-.314Zm-.292-5.111a2.308,2.308,0,0,1-2.58,2.438H1307v-4.874h3.063a2.307,2.307,0,0,1,2.58,2.436",
    fill: "#231f20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.5122c83b12f42b1a2a27d0d478ff89c3.svg";
export { ForwardRef as ReactComponent };